import { isExtensionSupported } from '@bynder/image-gen-frontend-lib';
/**
 * Utility functions for image generation AI features
 */

import { AssetStatus } from 'packages/types/assets';

export type ImageGenInput = {
    status?: AssetStatus;
    mimeType?: string;
    extension?: string;
};

/**
 * List of allowed MIME types for AI image generation
 */
export const ALLOWED_IMAGE_MIME_TYPES = [
    'image/png',
    'image/jpeg',
    'image/tiff',
    'image/webp',
    'image/heif',
    'image/heic',
    'image/avif',
    'image/svg+xml',
    'application/postscript',
    'image/bmp',
    'image/vnd.wap.wbmp',
    'image/gif',
] as const;

/**
 * Check if the given MIME type is allowed for AI image generation
 * @param mimeType - MIME type string
 * @returns true if MIME type is allowed
 */
export const isAllowedMimeType = (mimeType: string): boolean => {
    return ALLOWED_IMAGE_MIME_TYPES.includes(mimeType.toLowerCase() as (typeof ALLOWED_IMAGE_MIME_TYPES)[number]);
};

/**
 * Check if an image is allowed to be used for AI generation based on its source or MIME type
 * @param input - Object with src (URL), mime (MIME type), status, and mimeType
 * @returns true if the image format is allowed
 */
export const isAllowedImageFormat = (input: ImageGenInput): boolean => {
    if (!input) {
        return false;
    }

    if (input.mimeType) {
        return isAllowedMimeType(input.mimeType);
    }

    if (input.extension) {
        return isExtensionSupported(input.extension);
    }

    return false;
};
